import PartnerBusinesses from "../../features/partner-businesses/PartnerBusinesses";

export default function PartnerBusinessesPage() {
  return (
    <div>
      <PartnerBusinesses />
    </div>
  );
}
